import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StatusEventPageDataService} from '@services/pages/status-event-page/data/status-event-page-data.service';
import {StatusEventPageEventDisplayDetails} from '@models/pages/status-event-page/status-event-page-event-display-details';
import {StatusEventType} from '@constants/machine/status-event-signal/status-event-type.enum';

@Component({
    selector: 'scitis-machine-status-events-table',
    templateUrl: './machine-status-events-table.component.html',
    styleUrls: ['./machine-status-events-table.component.scss'],
    standalone: false
})
export class MachineStatusEventsTableComponent {

  @Input()
  public statusEvents: StatusEventPageEventDisplayDetails[] = [];

  @Input()
  public isLoading: boolean = true;

  @Output()
  private loadMore: EventEmitter<void> = new EventEmitter<void>();

  @Output()
  private redirectToStatusPage: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private statusEventPageDataService: StatusEventPageDataService,
  ) {
  }

  public formatDate(timestamp: number): string {
    return this.statusEventPageDataService.formatDate(timestamp);
  }

  public onLoadMore(): void {
    this.loadMore.emit();
  }

  public getTypeIcon(type: StatusEventType): string {
    switch (type) {
      case StatusEventType.FAILURE:
        return 'fa-triangle-exclamation text-danger';
      case StatusEventType.WARNING:
        return 'fa-circle-exclamation text-warning';
      case StatusEventType.INFO:
        return 'fa-circle-info text-info';
      case StatusEventType.INHIBIT:
        return 'fa-ban text-inhibit';
      case StatusEventType.DEBUG:
        return 'fa-tools text-debug';
      default:
        return 'fa-circle-question';
    }
  }

  public onRedirectToStatusPage(signalName: string) {
    this.redirectToStatusPage.emit(signalName);
  }
}
